import { useContext, useEffect, useRef } from "react";
import { NameContext } from "../context/NameContext";
import KompassOverview from "../kits/ManifestKit/KompassOverview";
import { HashLink } from "react-router-hash-link";
import { loadModelViewer } from "../utils/loadModelViewer";
import SeoHelmet from "../components/SeoHelmet";
import { logoBackPath } from "../config";

import MonoButton from "../kits/DesignKit/MonoButton";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";

function Hero({ className = "" }) {
  const {
    name,
    setName,
    setIsNameEntered,
  } = useContext(NameContext);

  useEffect(() => {
    loadModelViewer();
  }, []);

  const kompassRef = useRef(null);

  return (
    <>
      <SeoHelmet
        title="Denis Bitter – Software Architect & Full-Stack Engineering Instructor"
        description="React · Angular · Flutter · UI Engineering · System Architecture. Ich entwickle klare Systeme für Lernen, Web & App – durchdacht, echt, skalierbar. EdTech. Medien. Lösungen mit Haltung."
        url="https://www.denisbitter.de/"
        image="https://www.denisbitter.de/images/hero-og.jpg"
      />

      <section
        className={`relative overflow-hidden min-h-screen px-4 font-mono ${className}`}
        style={{
          background: "linear-gradient(180deg, #2a1035 0%, #141629 30%, #0b1020 100%)"
        }}
      >
        <div className="pointer-events-none absolute inset-0 opacity-80">
          <div className="absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-fuchsia-500/30 blur-[120px]" />
          <div className="absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-violet-500/30 blur-[120px]" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center text-center pt-24 sm:pt-28 pb-16 sm:pb-20">
          <HashLink
            smooth
            to="/about"
            scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
          >
            <MonoButton
              className="rounded-full border border-brand bg-fuchsia-500/10 px-4 py-1.5 text-xs sm:text-sm font-semibold text-fuchsia-200"
              underlineColors="ZenBrand"
            >
              Software Architect · Full-Stack Engineering
            </MonoButton>
          </HashLink>
       

          <h1 className="mt-8 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white">
            Software Architect &amp; Full-Stack Engineering Instructor
            <span className="mt-2 block text-brand drop-shadow-[0_0_12px_rgba(215,172,116,0.35)]">
              FullStack Entwickler
            </span>
          </h1>

          <p className="mt-4 text-sm sm:text-base text-slate-300">
            React · Angular · Flutter · UI Engineering · System Architecture
          </p>
          <p className="mt-2 text-xs text-slate-400">
            #Systemarchitektur #DigitaleBildung #FullStackEntwicklung
          </p>

          <div className="w-full flex justify-center mt-10">
            <HashLink
              smooth
              to="/about#kompass"
              scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
              className="w-full max-w-4xl"
            >
              <div
                ref={kompassRef}
                className="relative p-3 sm:p-4"
              >
                <KompassOverview className="w-full" />
      
              </div>
            </HashLink>
          </div>

          <HashLink
            smooth
            to="/about"
            scroll={(el) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
            className="mt-6"
          >
         
          </HashLink>

          <div className="max-w-2xl w-full mx-auto mt-8">
            <h2 className="sr-only">Werte</h2>
            <p className="text-xs sm:text-sm leading-relaxed text-center text-slate-300">
              Ich glaube an Systeme, die verständlich sind.
              <br />
              An Bildung, die bleibt. Und an Ideen, die nutzbar werden.
              <br />
              <br />
              Wenn Kreativität, Technologie &amp; Haltung zusammenkommen, entsteht echte Wirkung.
            </p>
          </div>
        </div>
      </section>
    </>
  );

}

export default Hero;
